import { useSelector } from "react-redux";

export function useGetIndividualInclusionMemberDetails(userGroupUniqueName, userId) {
  let userGroupIndividualInclusions = useSelector(
    (rootState) => rootState.userGroup.userGroupDetails[userGroupUniqueName]?.value?.individualInclusionMembers
  );
  function getIndividualInclusionMember(individualInclusionMember) {
    return individualInclusionMember?.userId === userId;
  }
  return userGroupIndividualInclusions?.find(getIndividualInclusionMember);
}
